import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IFAQs } from 'src/app/interfaces/ifaqs';
import { IFAQsDisplay } from 'src/app/interfaces/ifaqs-display';
import { FaqsService } from 'src/app/services/faqs.service';
import { GeneralService } from 'src/app/services/general.service';
import { TranslatorService } from 'src/app/services/translator.service';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    standalone: false
})
export class FAQsComponent {
     faqSet: IFAQs[] = [];
     userFilter: string[] = [];
     userFilter_EN: string[] = [];
     userFilter_FR: string[] = [];
     userFilter_ES: string[] = [];
     userFilterSet: string[] = [];
     topicFilter: string[] = [];
     topicFilter_EN: string[] = [];
     topicFilter_FR: string[] = [];
     topicFilter_ES: string[] = [];
     topicFilterSet: string[] = [];
     countUser: { [key: string]: string } = {};
     countUser_FR: { [key: string]: string } = {};
     countUser_ES: { [key: string]: string } = {};
     countTopic: { [key: string]: string } = {};
     countTopic_FR: { [key: string]: string } = {};
     countTopic_ES: { [key: string]: string } = {};
     loading: boolean = true;
     rowsToDisplay: IFAQsDisplay[] = [];
     oneDisplay?: IFAQsDisplay;
     showFAQs: string = "10";
     searchTxt: string = "";
     openItem: number = -1;
     selectedLanguage: string = 'en';
     translatedFaqs: IFAQsDisplay[] = [];
     previewItemId?: string;
     previewParentItemId: string = '';

     constructor(public generalService: GeneralService, 
          public faqsService: FaqsService, 
          public translatorService: TranslatorService,
          private router: Router) {
          let faqsPromise:any;
          var params = this.generalService.getQueryParameters(this.router.url);
          if (params && params['previewItemId']) {
               this.previewItemId = params['previewItemId']
               if (params && params['previewParentItemId']) {
                    this.previewParentItemId = params['previewParentItemId']
               }     
               faqsPromise = faqsService.getFAQsForPreview(this.previewItemId, this.previewParentItemId);
          } else {
               faqsPromise = faqsService.getFAQs();
          }
          faqsPromise.subscribe((result: any) => this.showFAQResults(result));
          this.selectedLanguage = translatorService.activeLanguage;
     }

     ngOnInit() {
          // Subscribe to changes in the service variable
          this.translatorService._hasChanges$.subscribe(newValue => {
               if (newValue === true) {
                    this.translatorService.resetHasChange();
                    this.resetCheckboxFilters();
                    this.resetFilters();
               }
          });
          setTimeout(() => this.scrollToTop(), 500);
     }

     get faqsToDisplay(): IFAQsDisplay[] {
          this.rowsToDisplay = this.translatedFaqs.filter(faq => {
               return (faq.displayed === true)
          });
          return this.rowsToDisplay;
     }

     get userFilterToDisplay(): string[] {
          if (this.translatorService.activeLanguage === 'en') {
               return this.userFilter_EN;
          } else if (this.translatorService.activeLanguage === 'fr') {
               return this.userFilter_FR;
          } else if (this.translatorService.activeLanguage === 'es') {
               return this.userFilter_ES;
          }
          return [];
     }

     get topicFilterToDisplay(): string[] {
          if (this.translatorService.activeLanguage === 'en') {
               return this.topicFilter_EN;
          } else if (this.translatorService.activeLanguage === 'fr') {
               return this.topicFilter_FR;
          } else if (this.translatorService.activeLanguage === 'es') {
               return this.topicFilter_ES;
          }
          return [];
     }

     showFAQResults(results: any[]) {
          if (results && results[0] === 'true') {
               this.faqSet = this.faqsService.faqSet;

               this.userFilter_EN = this.faqsService.userFilter;
               this.userFilter_FR = this.faqsService.userFilter_FR;
               this.userFilter_ES = this.faqsService.userFilter_ES;

               this.topicFilter_EN = this.faqsService.topicFilter;
               this.topicFilter_FR = this.faqsService.topicFilter_FR;
               this.topicFilter_ES = this.faqsService.topicFilter_ES;

               this.translatedFaqs = [];
               this.faqSet.forEach((faq: IFAQs) => {
                    if (this.translatorService.activeLanguage === 'fr') {
                         const displayItem:IFAQsDisplay = {question:faq.question_FR,answer:faq.answer_FR,tags:faq.tags_FR,stakeHolders:faq.stakeHolders_FR,displayed:faq.displayed,index:faq.index,featuredOrder:faq.featuredOrder}
                         this.translatedFaqs.push(displayItem);
                    } else if (this.translatorService.activeLanguage === 'es') {
                         const displayItem:IFAQsDisplay = {question:faq.question_ES,answer:faq.answer_ES,tags:faq.tags_ES,stakeHolders:faq.stakeHolders_ES,displayed:faq.displayed,index:faq.index,featuredOrder:faq.featuredOrder}
                         this.translatedFaqs.push(displayItem);
                    }else if(this.translatorService.activeLanguage === 'en'){
                         const displayItem:IFAQsDisplay = {question:faq.question,answer:faq.answer,tags:faq.tags,stakeHolders:faq.stakeHolders,displayed:faq.displayed,index:faq.index,featuredOrder:faq.featuredOrder}
                         this.translatedFaqs.push(displayItem);
                    }
               });

               this.countUser = this.faqsService.countUser;
               this.countUser_FR = this.faqsService.countUser_FR;
               this.countUser_ES = this.faqsService.countUser_ES;
               this.countTopic = this.faqsService.countTopic;
               this.countTopic_FR = this.faqsService.countTopic_FR;
               this.countTopic_ES = this.faqsService.countTopic_ES;

               this.rowsToDisplay = this.translatedFaqs.filter(faq => {
                    return (faq.displayed === true)
               });
          } else {
               this.faqSet = [];
          }
          this.loading = false;
     }

     getCountUser(user: string): number {

          let rowsShowing: IFAQsDisplay[] = [];
          if (this.userFilterSet.length === 0 && this.topicFilterSet.length === 0 && this.searchTxt === "") {
               const count: any = this.translatorService.activeLanguage === "en" ? this.countUser[user] :
                    (this.translatorService.activeLanguage === "es" ? this.countUser_ES[user] : this.countUser_FR[user]);
               return count;
          } else {
               rowsShowing = this.translatedFaqs.filter(faq => {
                    return (faq.stakeHolders === null ? false : faq.displayed === true && faq.stakeHolders.includes(user))
                });
               return rowsShowing.length;
          }
     }

     getCountTopic(topic: string): number {
          let rowsShowing: IFAQsDisplay[] = [];
          const count: any = this.translatorService.activeLanguage === "en" ? this.countTopic[topic] : 
               (this.translatorService.activeLanguage === "es" ? this.countTopic_ES[topic] : this.countTopic_FR[topic]);

          if (this.topicFilterSet.length === 0 &&
               this.userFilterSet.length === 0 &&
               this.searchTxt === "") {
               return count;
          } else {
               rowsShowing = this.translatedFaqs.filter(faq => {
                    return faq.tags === null ? false : faq.displayed === true && faq.tags.includes(topic);
               });
          }
          return rowsShowing.length;
     }


     showNoFAQs(): boolean {
          const rowsShowing = this.translatedFaqs.filter(faq => {
               return (faq.displayed === true)
          });
          return (rowsShowing.length > 0 ? false : true)
     }

     testRow() {
          if (this.showFAQs === 'search' && this.searchTxt === '') {
               this.showFAQs = 'All';
          }

          for (let i: number = 0; i < this.translatedFaqs.length; i++) {
               const row = this.faqSet[i];
               if (row.stakeHolders === null || row.tags === null) {
                    row.displayed = false;
               } else if (this.searchTxt !== '' || this.userFilterSet.length > 0 || this.topicFilterSet.length > 0) {
                    if (this.showFAQs !== "search") {
                         
                         this.openItem = -1;
                         this.showFAQs = 'search';
                    }
                    this.rowMatchTest(this.translatedFaqs[i]);
               } else if (this.showFAQs === '10' && row.index > 0 && row.index < 10) {
                    this.translatedFaqs[i].displayed = true;
               } else if (this.showFAQs === 'All') {
                    this.translatedFaqs[i].displayed = true;
               } else {
                    this.translatedFaqs[i].displayed = false;
               }
          };

          this.rowsToDisplay = this.translatedFaqs.filter(faq => {
               return (faq.displayed === true)
          });
     }

     rowMatchTest(row: IFAQsDisplay) {
          if ((row.question.toLowerCase().indexOf(this.searchTxt.toLowerCase().trim()) > -1
               || row.answer.toLowerCase().indexOf(this.searchTxt.toLowerCase().trim()) > -1)
               && this.doseRowHaveAllUsersMatch(row.stakeHolders) && this.doseRowHaveAllTopicsMatch(row.tags)) {

               row.displayed = true;
          } else {
               row.displayed = false;
          }
     }

     getTotalRows() {
          const totalRows: IFAQsDisplay[] = this.translatedFaqs.filter(faq => {
               return (faq.displayed === true)
          });

          if (totalRows.length === 1) {
               this.rowMatchTest(totalRows[0]);
               if (totalRows[0].displayed === true) {
                    this.oneDisplay = totalRows[0];
               }
          }

          return totalRows.length;
     }

     private doseRowHaveAllUsersMatch(rowUsers: string[]): boolean {
          if (this.userFilterSet.length === 0) {
               return true;
          }
          const userMatch = this.userFilterSet.filter(element => rowUsers.includes(element));
          if (userMatch.length === this.userFilterSet.length) {
               return true;
          } else {
               return false;
          }
     }

     private doseRowHaveAllTopicsMatch(rowTopics: string[]): boolean {
          if (this.topicFilterSet.length === 0) {
               return true;
          }
          const topicMatch = this.topicFilterSet.filter(element => rowTopics.includes(element));
          if (topicMatch.length === this.topicFilterSet.length) {
               return true;
          } else {
               return false;
          }
     }

     setOn(index: number) {
          if (this.openItem === index) {
               this.openItem = -1
          } else {
               this.openItem = index;
          }
     }

     showAllSearch() {
          this.userFilterSet = [];
          this.topicFilterSet = [];

          this.showFAQs = 'All';
          this.searchTxt = '';
          this.openItem = -1;
          this.showFAQResults(['true']);
          this.testRow();
     }

     showTop10() {
          this.resetFilters()
          this.openItem = -1;
          setTimeout(() => this.scrollToTop(), 500);
     }

     resetFilters() {
          this.scrollToTop();
          this.userFilterSet = [];
          this.topicFilterSet = [];
          this.searchTxt = "";
          this.showFAQs = "10";
          this.faqsService.baseFAQPageState();
          this.showFAQResults(['true']);
          setTimeout(() => this.scrollToTop(), 500);
     }

     resetCheckboxFilters() {
          if (this.searchTxt === '') {
               this.resetFilters();
          } else {
               this.userFilterSet = [];
               this.topicFilterSet = [];
               this.testRow();
          }
     }

     clearSearchText() {
          this.searchTxt = '';
          if (this.userFilterSet.length === 0 && this.topicFilterSet.length === 0 && this.searchTxt === '') {
               this.resetFilters();
          } else {
               this.testRow();
          }
     }

     testUser(user: string) {
          var isIn = this.userFilterSet.includes(user);
          return isIn;
     }

     filterUser(user: string) {
          const dex: number = this.userFilterSet.indexOf(user);
          if (dex === -1) {
               this.userFilterSet.push(user)
          } else {
               this.userFilterSet.splice(dex, 1);
               if (this.userFilterSet.length === 0 && this.topicFilterSet.length === 0 && this.searchTxt === '') {
                    this.resetFilters();
                    return;
               }
          };
          if (this.showFAQs !== "search") {
               this.showFAQs = "search"
          };
          this.testRow();
     }

     filterTopic(topic: string) {
          const dex: number = this.topicFilterSet.indexOf(topic);
          if (dex === -1) {
               this.topicFilterSet.push(topic)
          } else {
               this.topicFilterSet.splice(dex, 1)
               if (this.userFilterSet.length === 0 && this.topicFilterSet.length === 0 && this.searchTxt === '') {
                    this.resetFilters();
                    return;
               }
          };
          if (this.showFAQs !== "search") {
               this.showFAQs = "search"
          };
          this.testRow();
     }

     getFAQByQuestion(question: string, part: string = ("'a','q'")) {
          var valToReturn = this.faqsService.faqSet.find(v => v.question === question);
          if (this.translatorService.activeLanguage === 'en') {
               switch (part) {
                    case 'a':
                         return valToReturn?.answer;
                    case 'q':
                         return valToReturn?.question;
               }

          } else if (this.translatorService.activeLanguage === 'es') {
               switch (part) {
                    case 'a':
                         return valToReturn?.answer_ES;
                    case 'q':
                         return valToReturn?.question_ES;
               }

          } else {
               switch (part) {
                    case 'a':
                         return valToReturn?.answer_FR;
                    case 'q':
                         return valToReturn?.question_FR;
               }
          }
          return '';
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
